import { Box, Button, CircularProgress, Grid, Stack, Typography } from '@mui/material';
import React, { useEffect } from 'react'
import Images from '../../../utils/Images';
import { ArrowForwardOutlined, CheckCircle, EmojiEmotionsOutlined, ForkRightOutlined, KeyboardArrowRightSharp, QuestionMarkOutlined, ShoppingCart, TurnRight } from '@mui/icons-material';
import { API } from '../../../utils/Api';
import axios from 'axios';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const iconMap = {
  cart: <ShoppingCart fontSize="small" sx={{ color: '#fff' }} />,
  check: <CheckCircle fontSize="small" sx={{ color: '#fff' }} />,
  smile: <EmojiEmotionsOutlined fontSize="small" sx={{ color: '#fff' }} />,
};

const steps = [
  { text: 'Purchase your preferred subscription plans', icon: 'cart' },
  { text: 'Select applicable items in the plans and place your order', icon: 'check' },
  { text: 'Enjoy Xpanse!', icon: 'smile' },
];

const SubscriptionScreen = () => {
  const navigate = useNavigate();
  const token = localStorage.getItem('token');
  const [outletData, setOutletData] = useState(JSON.parse(localStorage.getItem('selectedStoreData')));
  const [subscriptions, setSubscriptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [tab, setTab] = useState('explore');
  const [userData, setUserData] = useState(JSON.parse(localStorage.getItem('userDataLogin')));

  const getSubscriptions = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${API.BASE_URL}subscription-purchase/purchasestatus/${outletData?._id}?userId=${userData?._id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setSubscriptions(response?.data?.data?.list);
      setLoading(false);
    } catch (error) {
      console.log("Error in getting Ads", error?.response);
    } finally {
      setLoading(false);
    }
  };

  const handleRedirect = (sub) => {
    if (!token) {
      navigate('/mobileNumber');
    } else {
      navigate('/subscriptionPurchase', { state: { sub } });
    }
  };

  useEffect(() => {
    getSubscriptions();
  }, []);

  const [now, setNow] = useState(Date.now());

  useEffect(() => {
    const timer = setInterval(() => {
      setNow(Date.now());
    }, 60000);
    return () => clearInterval(timer);
  }, []);

  function getSubscriptionOrderStatus(sub) {
    const today = new Date().toLocaleString('en-US', { weekday: 'long' }); // e.g., "Friday"
    if (sub?.excludedDays && sub.excludedDays.includes(today)) {
      return { msg: "Your next coffee is due tommorow", wait: true, excludedDay: true };
    }

    if (!sub?.lastOrderDatetime) return { msg: 'Proceed to menu', wait: false };
    const lastOrder = new Date(sub.lastOrderDatetime.replace(/-/g, '/'));
    const now = new Date();
    if (sub.subscriptionType === 'DAILY') {
      const isToday = now.toDateString() === lastOrder.toDateString();
      if (isToday) {
        return { msg: 'You can order next day', wait: true };
      }
      return { msg: 'Proceed to menu', wait: false };
    }
    if (sub.subscriptionType === 'HOURLY') {
      const diffMs = now - lastOrder;
      const diffMins = Math.floor(diffMs / 60000);
      const waitMins = sub.redemptionInterval - diffMins;
      if (waitMins > 0) {
        return { msg: `You can place order after ${waitMins} min${waitMins > 1 ? 's' : ''}`, wait: true };
      }
      return { msg: 'Proceed to menu', wait: false };
    }
    return { msg: 'Proceed to menu', wait: false };
  }

  return (
    <>
      {loading ? (
        <CircularProgress />
      ) : (
        <>
          {subscriptions?.some(subscription => subscription?.purchased) && (
            <>
              <Grid container className="subTabs" justifyContent="space-around">
                <Grid
                  item xs={5}
                  className={`tab ${tab === 'explore' ? 'active' : ''}`}
                  onClick={() => setTab('explore')}
                >
                  Explore
                </Grid>
                <Grid
                  item xs={5}
                  className={`tab ${tab === 'active' ? 'active' : ''}`}
                  onClick={() => setTab('active')}
                >
                  Active
                </Grid>
              </Grid>
            </>
          )}
          {tab === 'active' && (
            <Box className="subscriptionScreen">
              {subscriptions?.some(subscription => subscription?.purchased) && (
                <Stack
                  direction={'row'}
                  sx={{
                    my: 2, mb: 0, px: 3,
                    background: 'linear-gradient(to right, #FDFF7D, #FFFED9)',
                    color: '#0ED511',
                    borderRadius: '40px',
                    width: 'fit-content',
                    alignItems: 'center',
                    alignSelf: 'center',
                    justifySelf: 'center'
                  }}>
                  <Typography fontWeight={'600'}>Active Plans</Typography>
                  <img src={Images.activePlanBird} alt="Active Plan" />
                </Stack>
              )}

              <Box className="subscriptionList">
                {subscriptions
                  ?.filter(subscription => subscription?.purchased && !(subscription?.excludedOutlets && subscription?.excludedOutlets?.includes(outletData?._id)))
                  .map((sub, index) => {
                    const orderStatus = getSubscriptionOrderStatus(sub);
                    return (
                      <Box className={`subscriptionPlan ${orderStatus.wait ? 'inActive' : ''}`} key={index}>
                        <img className='subImage' src={sub?.banner_imageUrl} style={{ width: '100%' }} />
                        <Typography className='planName'>{sub?.title}</Typography>

                        {/* ONLY ONE BUTTON */}
                        <Stack direction="row" justifyContent="space-between" alignItems="center">
                          <Typography
                            className={`button ${orderStatus.wait ? 'inActive' : ''}`}
                            sx={{
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              position: 'relative',
                              px: 4,
                              py: 1,
                              opacity: orderStatus.wait ? 0.6 : 1,
                              pointerEvents: orderStatus.wait ? 'none' : 'auto',
                              cursor: orderStatus.wait ? 'not-allowed' : 'pointer',
                            }}
                            onClick={() => {
                              if (!orderStatus.wait) navigate('/subscriptionMenu', { state: { sub } });
                            }}
                          >
                            <Typography color="#fff" fontWeight={'600'}>
                              {orderStatus.msg}
                            </Typography>
                            <KeyboardArrowRightSharp sx={{ position: 'absolute', right: 4, color: '#fff' }} />
                          </Typography>
                        </Stack>

                        {/* <Stack direction="row" justifyContent="space-between" alignItems="center">
                          <Typography
                            className={`button ${orderStatus.wait ? 'inActive' : ''}`}
                            sx={{
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              position: 'relative',
                              px: 4,
                              py: 1,
                              opacity: orderStatus.wait ? 0.6 : 1,
                              pointerEvents: 'auto',
                              cursor: orderStatus.wait ? 'not-allowed' : 'pointer',
                            }}
                            onClick={() => {
                              navigate('/subscriptionMenu', { state: { sub } });
                            }}
                          >
                            <Typography color="#fff" fontWeight={'600'}>
                              {orderStatus.msg}
                            </Typography>
                            <KeyboardArrowRightSharp sx={{ position: 'absolute', right: 4, color: '#fff' }} />
                          </Typography>
                        </Stack> */}
                      </Box>
                    );
                  })}
              </Box>
            </Box>
          )}

          {tab === 'explore' && (
            <Box className="subscriptionScreen">

              <img style={{ width: '100%' }} src={Images.subscriptionBanner} alt='SubscriptionBanner' />

              <Grid container sx={{ paddingTop: 2 }}>
                <Grid className='title' item xs={8}>
                  <span className='unlimitedText'>Unlimited</span> Xpanse? <br />
                  Yes Please!
                </Grid>
                <Grid item xs={3} sx={{ padding: 2, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <img style={{ width: '100%' }} src={Images.xpanseLogo} alt='Xpanse Logo' />
                </Grid>
                <Grid item xs={12} className='titleDesc'>
                  Enjoy huge savings with Xpanse subscription plans, specially made for all types of needs.
                </Grid>
              </Grid>

              {/* <Box className="work">
                <Typography className='title'>How does it work?</Typography>
                <Box sx={{ display: 'flex', flexDirection: 'column', pl: 2, position: 'relative', zIndex: -10 }}>
                  {steps.map((step, index) => (
                    <Stack
                      key={index}
                      direction="row"
                      spacing={2}
                      sx={{
                        alignItems: 'flex-start',
                        position: 'relative',
                        mb: index === steps.length - 1 ? 0 : 3,
                      }}
                    >
                      <Box
                        sx={{
                          width: '32px',
                          minWidth: '32px',
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'center',
                          position: 'relative',
                        }}
                      >
                        <Box
                          sx={{
                            width: 32,
                            height: 32,
                            borderRadius: '50%',
                            backgroundColor: '#03a9f4',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            zIndex: 2,
                          }}
                        >
                          {iconMap[step.icon] || <Box />}
                        </Box>
                        {index !== steps.length - 1 && (
                          <Box
                            sx={{
                              position: 'absolute',
                              top: 32,
                              width: '12px',
                              height: 'calc(100% + 12px)',
                              backgroundColor: '#03a9f4',
                              zIndex: 1,
                            }}
                          />
                        )}
                      </Box>
                      <Typography variant="body1" sx={{ mt: '4px', color: '#6C6C6E' }}>
                        {step.text}
                      </Typography>
                    </Stack>
                  ))}
                </Box>
              </Box> */}
              {!subscriptions?.length <= 0 ? (
                <Box className="subscriptionList">
                  <Typography className='title'>Select Your Plan</Typography>

                  {subscriptions?.filter(subscription => !subscription?.purchased && !(subscription?.excludedOutlets && subscription?.excludedOutlets?.includes(outletData?._id))).map((sub, index) => (
                    <Box onClick={() => handleRedirect(sub)} className="subscriptionPlan" key={index}>
                      <img src={sub?.banner_imageUrl} style={{ width: '100%' }} />
                      <Typography className='planName'>{sub?.title}</Typography>
                      <Stack direction="row" justifyContent="space-between" alignItems="center">
                        <Typography className="amount" fontWeight={800} sx={{ textAlign: 'baseline' }}>
                          Amount: {sub?.price}/-
                        </Typography>
                        <Typography
                          className="button"
                          sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            position: 'relative',
                            px: 4,
                            py: 1,
                            width: '20%'
                          }}
                        >
                          <Typography color="#fff">Proceed</Typography>
                          <KeyboardArrowRightSharp
                            sx={{
                              position: 'absolute',
                              right: 4,
                              color: '#fff',
                            }}
                          />
                        </Typography>
                      </Stack>
                    </Box>
                  ))}
                </Box>
              ) : (
                <Box className="subscriptionList">
                  <img style={{ display: 'flex', alignSelf: 'center', justifySelf: 'center' }} alt='subSearchBird' src={Images.subSearchBird} />
                  <Typography className='title'>Plans coming soon...</Typography>
                </Box>
              )}

              {!subscriptions?.length <= 0 && (
                <Button className="faqButton" onClick={() => navigate('/subscriptionFaq')}>
                  <QuestionMarkOutlined />
                </Button>
              )}

            </Box>
          )}
        </>
      )
      }
    </>
  )
}

export default SubscriptionScreen;
